'use es6';

import hubspotMobileApp from 'bender-url!../../img/hubspotMobileApp.png';
import microsoftLogo from 'bender-url!../../img/ms-logo.png';
export default {
  hubspotMobileApp,
  microsoftLogo
};